import { handleError } from '@/utils/errors';

/**
 * Copies a string to clipboard
 * @param string String to copy to clipboard
 */

// eslint-disable-next-line require-await
async function fallbackCopyStringToClipboard(string) {
  const copy = document.createElement('textarea');

  document.body.appendChild(copy);
  copy.value = string;
  copy.select();

  try {
    document.execCommand('copy');

    Promise.resolve();
  } catch (error) {
    handleError(error, 'Unable to copy to clipboard');
  } finally {
    document.body.removeChild(copy);
  }
}

// eslint-disable-next-line require-await
export default async function copyStringToClipboard(string) {
  if (!navigator.clipboard) {
    return fallbackCopyStringToClipboard(string);
  }

  return navigator.clipboard.writeText(string);
}
